var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M5.972 17.153c-.42-.42-.459-1.078-.115-1.542l.115-.133L11.45 10 5.972 4.522c-.42-.42-.459-1.079-.115-1.542l.115-.133c.42-.42 1.078-.459 1.542-.115l.133.115 6.315 6.316c.42.42.459 1.078.115 1.541l-.115.133-6.315 6.316c-.463.463-1.213.463-1.675 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow2);
export default __webpack_public_path__ + "static/media/right-arrow-2.396af1fd1827afcba12a7cf298286c41.svg";
export { ForwardRef as ReactComponent };